export const EResourcesState = {
	Created: "created",
	Pending: "pending",
	SuccessResponse: "successResponse",
	Ready: "ready",
	Error: "error",
};
